/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InAppNotificationPriority } from './inAppNotificationPriority';


export interface CustomerInAppNotificationResponseDto { 
    id?: number;
    title?: string | null;
    description?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    priority?: InAppNotificationPriority;
}
export namespace CustomerInAppNotificationResponseDto {
}


